var render = function render(){var _vm=this,_c=_vm._self._c;return _c('broadcast-card',{attrs:{"eyebrow":"Πριν τον αγώνα","title":"Μέσοι όροι σεζόν"}},[_c('broadcast-compare',{attrs:{"sides":_vm.sides,"rows":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }